import React, { HTMLAttributes } from 'react'

import styled from '@emotion/styled'
import { useTheme } from '@gousto-internal/citrus-react'

export const ProcessImageElement = (props: HTMLAttributes<HTMLDivElement>) => {
  const { theme } = useTheme()

  const breakpointFromMedium = theme.tokens.breakpoints[0]
  const breakpointFromLarge = theme.tokens.breakpoints[1]
  const breakpointFromXLarge = theme.tokens.breakpoints[2]

  const BreakpointFromMedium = `@media (min-width: ${breakpointFromMedium})`
  const BreakpointFromLarge = `@media (min-width: ${breakpointFromLarge})`
  const BreakpointFromXLarge = `@media (min-width: ${breakpointFromXLarge})`

  const Component = styled.div({
    picture: {
      display: 'flex',

      width: '100%',
      height: '100%',
    },

    img: {
      display: 'none',

      [BreakpointFromMedium]: {
        display: 'flex',

        width: '100%',
        height: '10.875rem',
        objectPosition: 'left bottom',
        objectFit: 'contain',
      },

      [BreakpointFromLarge]: {
        height: '12.875rem',
        marginBottom: 0,
      },

      [BreakpointFromXLarge]: {
        height: '16.3rem',
      },
    },
  })

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}
